<h1 class="setting-title" i18n="@@settings_deleteAccount_title">
  Delete account
</h1>
<div>
  <p i18n="@@settings_deleteAccount_description1">
    You are about to delete your account and initiate a data deletion process.
    Please read the following to fully understand what awaits you when
    initiating this application.
  </p>
  <p i18n="@@settings_deleteAccount_description2">
    Once the process has started, you will no longer be able to log in to your
    account. The deletion request is password protected which means that only
    the account holder can initiate the process.
  </p>
  <p i18n="@@settings_deleteAccount_description3">
    Your account will be deleted, which means that your personal data will be
    deleted or anonymized. You will therefore no longer be able to access the
    personal data of your patients collected through the use of NMOSDCopilot®.
    It will also no longer be possible for users of the MG&Me® application to
    find you or send you pairing requests.
  </p>
</div>
<h3 class="mb-3 subtitle-setting" i18n="@@settings_deleteAccount_subtitle">
  In order to confirm the deletion of your account, please enter your password
</h3>
<form [formGroup]="deleteForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label
      class="lbl-patient fw-medium"
      for="pwd"
      i18n="@@settings_deleteAccount_formPasswordLabel"
    >
      Password
    </label>
    <div class="d-flex align-items-center">
      <input
        class="form-control"
        [type]="textType ? 'text' : 'password'"
        name="pwd"
        id="pwd"
        [class.invalid]="invalidPassword"
        [class.valid-input]="deleteForm.valid"
        formControlName="password"
        [ngClass]="{
          invalid:
            invalidPassword &&
            (deleteForm.get('password').dirty ||
              deleteForm.get('password').touched)
        }"
      />
      <span (click)="toggleTextType()" class="eye-input-normal">
        <ng-container
          *ngIf="
            (invalidPassword || deleteForm.invalid) &&
              (deleteForm.get('password').dirty ||
                deleteForm.get('password').touched);
            else validPasswordImg
          "
        >
          <img
            [src]="
              textType
                ? 'assets/icons/icon-hidden-password-red.svg'
                : 'assets/icons/icon-visible-password-red.svg'
            "
            alt="eye"
          />
        </ng-container>
        <ng-template #validPasswordImg>
          <img
            [src]="
              textType
                ? 'assets/icons/icon-hidden-password.svg'
                : 'assets/icons/icon-visible-password.svg'
            "
            alt="eye"
          />
        </ng-template>
      </span>
    </div>
    <ng-container
      *ngIf="
        deleteForm.get('password').invalid &&
        (deleteForm.get('password').dirty || deleteForm.get('password').touched)
      "
    >
      <small
        class="text-danger mt-1"
        *ngIf="deleteForm.get('password').errors['required']"
        i18n="@@settings_deleteAccount_formPasswordRequired"
      >
        password is required
      </small>
    </ng-container>
    <ng-container *ngIf="invalidPassword">
      <div
        class="text-danger mt-3 fw-medium"
        i18n="@@settings_deleteAccount_formPasswordInvalid"
      >
        Invalid password
      </div>
    </ng-container>
    <button
      type="submit"
      [disabled]="!deleteForm.valid"
      class="btn btn-primary mt-5 w-75"
    >
      <span i18n="@@settings_deleteAccount_title">Supprimer le compte</span>
      <span class="icon"
        ><img src="assets/icons/icon-white-arrow-right.svg" alt="arrow"
      /></span>
    </button>
  </div>
</form>
